import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ExcelUploadForm from "./form";
import ExcelTable from "./table";

const ExcelUpload = () => {
  const [showModal, setShowModal] = useState(false);
  const [tableKey, setTableKey] = useState(0); // Key to force table reload

  const handleUploadSuccess = () => {
    setShowModal(false); // Close modal
    setTableKey((prevKey) => prevKey + 1); // Force table reload
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle d-flex justify-content-between align-items-center">
        <div>
          <h1>Excel Data</h1>
          <nav>
            <ol className="breadcrumb mb-0 pb-0">
              <li className="breadcrumb-item">
                <a href="/">Masters</a>
              </li>
              <li className="breadcrumb-item active">Excel Data</li>
            </ol>
          </nav>
        </div>

        {/* Upload Excel Button */}
        <Button variant="primary" className="btn btn-primary" onClick={() => setShowModal(true)}>
          Upload Excel
        </Button>
      </div>

      <section className="section">
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">

                <ExcelTable key={tableKey} />

                {/* Bootstrap Modal */}
                <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                  <Modal.Header closeButton>
                    <Modal.Title>Upload Excel File</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <ExcelUploadForm onUploadSuccess={handleUploadSuccess} />
                  </Modal.Body>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ExcelUpload;
